import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Litecoin() {
  return (
    <PredictionPage
      title="Litecoin"
      content="This is the Litecoin AI Trading Predictions page."
      canonical="/cryptocurrencies/litecoin-ai-trading-predictions"
      categoryKey="nav.cryptocurrencies"
      categoryPath="/cryptocurrencies"
      symbol="LITECOIN"
    />
  );
}

export default Litecoin;
